import styled from "@emotion/styled";

export const LinkButton = styled.button({
  background: "none",
  border: "none",
  color: "#007fed",
  cursor: "pointer",
  ":hover": {
    textDecoration: "underline",
  },
});
